// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Vazirmatn[wght].woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Vazirmatn';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2 supports variations'),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2-variations');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
}
`, "",{"version":3,"sources":["webpack://./src/fonts/fonts.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB;sEACuD;IACvD,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["@font-face {\r\n    font-family: 'Vazirmatn';\r\n    src: url('Vazirmatn[wght].woff2') format('woff2 supports variations'),\r\n    url('Vazirmatn[wght].woff2') format('woff2-variations');\r\n    font-weight: 100 900;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
